import { useState } from 'react';
import { Monitor, Smartphone, Mail } from 'lucide-react';
import { clsx } from 'clsx';

interface PreviewPanelProps {
  html: string;
  recipientEmail?: string;
  subject?: string;
}

export function PreviewPanel({ html, recipientEmail, subject }: PreviewPanelProps) {
  const [device, setDevice] = useState<'desktop' | 'mobile'>('desktop');

  return (
    <div className="flex h-full flex-col rounded-xl border border-border-default bg-bg-primary overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-border-default bg-bg-tertiary px-3 py-2">
        <div className="flex items-center gap-2 min-w-0">
          <Mail className="h-3.5 w-3.5 shrink-0 text-text-muted" />
          <div className="min-w-0">
            {recipientEmail && <p className="truncate text-xs text-text-secondary">{recipientEmail}</p>}
            {subject && <p className="truncate text-xs font-medium text-text-primary">{subject}</p>}
          </div>
        </div>
        <div className="flex items-center gap-0.5 rounded-lg border border-border-default bg-bg-secondary p-0.5">
          <button
            type="button"
            onClick={() => setDevice('desktop')}
            className={clsx(
              'rounded-md p-1.5 transition-colors',
              device === 'desktop' ? 'bg-bg-primary text-accent shadow-sm' : 'text-text-muted hover:text-text-secondary'
            )}
          >
            <Monitor className="h-3.5 w-3.5" />
          </button>
          <button
            type="button"
            onClick={() => setDevice('mobile')}
            className={clsx(
              'rounded-md p-1.5 transition-colors',
              device === 'mobile' ? 'bg-bg-primary text-accent shadow-sm' : 'text-text-muted hover:text-text-secondary'
            )}
          >
            <Smartphone className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
      {/* Preview iframe */}
      <div className="flex-1 overflow-auto bg-[#e5e5e5] p-4">
        <div
          className={clsx(
            'mx-auto transition-all duration-300',
            device === 'mobile' ? 'max-w-[375px]' : 'max-w-full'
          )}
        >
          <iframe
            title="email-preview"
            srcDoc={html}
            sandbox=""
            className="w-full rounded-lg border-0 bg-white shadow-sm"
            style={{ height: 520 }}
          />
        </div>
      </div>
    </div>
  );
}
